import React from 'react';
export function Footer() {
  return <footer className="bg-black py-8 border-t border-dark-border text-center px-4" data-id="element-125" data-mp="32wmqdx7xtgw2">
      <div className="max-w-4xl mx-auto" data-id="element-126" data-mp="3gg1025qei1yp"><p className="text-gold-dark text-sm" data-id="element-127" data-mp="3gh3qydnq44em">© 2026 Food Science Teacher Ready™ — All rights reserved.</p></div>
    </footer>;
}